(function () {
    'use strict';

    angular.module('PWAPoCApp').controller('MapController', mapController);

    mapController.$inject = [
        '$rootScope',
        '$scope',
        '$timeout',
        'mapUtility',
        'mapService',
        'baseLayerFactory',
        'positionMarkerLayerFactory',
        'routeStopsLayerFactory',
        'flyFotoLayerFactory',
    ];

    function mapController(
        $rootScope,
        $scope,
        $timeout,
        mapUtility,
        mapService,
        baseLayerFactory,
        positionMarkerLayerFactory,
        routeStopsLayerFactory,
        flyFotoLayerFactory,
    ) {
        const rotationUpdateLimitKph = 5;

        //Fields
        $scope.currentPosition = {
            coords: {
                latitude: null,
                longitude: null
            }
        };
        $scope.mapService = mapService;
        $scope.followMe = true;
        $scope.rotateMap = false;

        //UI functions
        $scope.toggleFollowMe = () => $scope.followMe = !$scope.followMe;
        $scope.toggleFlyFoto = toggleFlyFoto;
        $scope.toggleRotateMap = rotationToggled;

        $scope.isFlyFotoLayerActive = false;

        $timeout(250).then(initController);

        function initController() {
            //Initialize map
            mapService.ready()
                .then(initMapService);

            //Add event listener
            $scope.$on('locationChanged', locationChanged);
        }

        function initMapService() {
            mapService.createMap('map');

            if (!mapService.isInitialized()) {
                mapService.addLayerFactory([
                    baseLayerFactory,
                    routeStopsLayerFactory,
                    positionMarkerLayerFactory,
                    flyFotoLayerFactory,
                ]);
            } else if ($rootScope.initRequired) {
                mapService.reInitialize();
                $rootScope.initRequired = false;
            }
        }

        function rotationToggled() {
            $scope.rotateMap = !$scope.rotateMap;
            if (!$scope.rotateMap) {
                mapService.rotate(0);
            }

            $rootScope.$broadcast('mapRotationToggled', $scope.rotateMap);
        }

        //Event handler functions
        function locationChanged(evt, position) {
            if (mapUtility.isValidPosition(position) && mapUtility.hasPositionChanged($scope.currentPosition, position)) {
                mapService.ready().then(() => {
                    if ($scope.rotateMap && position.coords.speed && position.coords.speed * 3.6 > rotationUpdateLimitKph) {
                        let newAngle = mapUtility.getAngleDiff($scope.currentPosition, position);
                        mapService.rotate(-newAngle);
                    }

                    if ($scope.followMe) {
                        mapService.zoomToPoint({
                            latitude: Number(position.coords.latitude),
                            longitude: Number(position.coords.longitude)
                        }, 14, true);
                    }

                    $scope.currentPosition = {
                        coords: {
                            latitude: Number(position.coords.latitude),
                            longitude: Number(position.coords.longitude)
                        }
                    };
                });
            }
        }

        function getLayerByName(name) {
            return mapService.layers.find(l => l.name === name);
        }

        function toggleFlyFoto() {
            const flyFotoLayer = getLayerByName('FlyFotoLayer');
            const baseLayer = getLayerByName('BaseMapLayer');

            if (!flyFotoLayer) return;

            const flyFotoVisible = !flyFotoLayer.visible;
            flyFotoLayer.visible = flyFotoVisible;

            $scope.isFlyFotoLayerActive = flyFotoVisible;

            if (baseLayer) {
                baseLayer.visible = !flyFotoVisible;
            }
        };

    }
})();
